
// <script async defer crossorigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js"></script>
// src="https://connect.facebook.net/en_US/sdk/debug.js" 

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import FN from "./fn";

// 第三方配置
const ThirdConfig = {
  // 龙珠fb参数
  '255-857': {
    facebookConfig: {
      appid: '952654606621840',
    }
  },
  // 火影fb参数
  '263-855': {
    facebookConfig: {
      appid: '2271008826600766',
    },
    afConfig: {
      AFKey: '034e21f8-c2fe-4ba3-b747-fa4a6d79f512',
    },
    firebaseConfig: {
      apiKey: "AIzaSyCNMPLbdLCU9N_LA5keTn_Sktb5IB7o4hA",
      authDomain: "dhy-855.firebaseapp.com",
      projectId: "dhy-855",
      storageBucket: "dhy-855.appspot.com",
      messagingSenderId: "511803607938",
      appId: "1:511803607938:web:9348d75ab42272fcaa1d9b",
      measurementId: "G-M6Z4GWP5PX"
    }
  },
}
const platform = {
  fb: false,
  af: false,
  fire: false
}

window.fbAsyncInit = function() {
  console.log('Async Init')
}

// facebook 初始化
const fbInit = (gameId, pfGameId) => {
  const facebookConfig = ThirdConfig[`${gameId}-${pfGameId}`]?.facebookConfig
  if (!facebookConfig) return
  platform.fb = true
  const init = (f,b,e,v,n,t,s) =>
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}
  init(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js')
  fbq('init', facebookConfig.appid);
  fbq('track', 'PageView');
}

// firebase 初始化
const firebaseInit = (gameId, pfGameId) => {
  // TODO: Add SDKs for Firebase products that you want to use
  // [https://firebase.google.com/docs/web/setup#available-libraries](#available-libraries)
  const firebaseConfig = ThirdConfig[`${gameId}-${pfGameId}`]?.firebaseConfig
  if (!firebaseConfig) return null
  platform.fire = true
  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  // Initialize Firebase
  const app = initializeApp(firebaseConfig)
  const analytics = getAnalytics(app)
  return analytics
}

// appsflyer 初始化
const afInit = (gameId, pfGameId) => {
  const afConfig = ThirdConfig[`${gameId}-${pfGameId}`]?.afConfig
  if (!afConfig) return
  platform.af = true
  function initFn(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){
    (t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},
    t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,
    o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),
    p.parentNode.insertBefore(o,p)}
  initFn(window,document,"script",0,"AF","pba",{pba: {webAppId: afConfig.AFKey}})
}

// 第三方初始化
export const thirdInit = (gameId, pfGameId) => {
  fbInit(gameId, pfGameId)
  firebaseInit(gameId, pfGameId)
  afInit(gameId, pfGameId)
}

// 第三方上报信息-运营数据 （登录/升级/充值）
export const thirdReport = (params) => {
  const data = {
    id: FN.getLocal('USER_INFO').old_id,
    ...params
  }
  // appsflyer 
  if (platform.af) {
    AF('pba', 'event', {eventType: 'EVENT', eventName: data.key, eventValue: data})
  }
  // firebase
  if (platform.fire) {
    gtag('event', data.key, data)
  }
  // facebook
  if (platform.fb) {
    fbq('trackCustom', data.key, data);
  }
}

// 第三方上报信息-市场数据 （只上报fb）
export const adReport = (type, params) => {
  // facebook
  if (platform.fb) {
    fbq('track', type, params);
  }
}
